<section class="content facial-evidence-page">
  <div class="content-block">
    <div class="block-header">
      <app-breadcrumb
        [title]="'MENUITEMS.ATTENDANCE.TEXT' | translate"
        [items]="[('facialEvidences.breadcrumb' | translate)]">
      </app-breadcrumb>
    </div>

    <div class="facial-evidence">
      <section class="evidence-filters" aria-label="Filtros">
        <div class="evidence-filters__fields">
          @if (companies.length > 1) {
          <div class="evidence-filter-control">
            <span class="evidence-filter-control__label">{{ 'orgUnitsCatalog.fields.company' | translate }}</span>
            <app-company-select class="evidence-filter-control__field" [records]="companies"
                                [value]="filters.companiesRecordId" [includeAll]="true"
                                [label]="'orgUnitsCatalog.fields.company' | translate"
                                [placeholder]="'common.all' | translate" [allLabel]="'common.all' | translate"
                                (valueChange)="onCompanyChanged($event)" />
          </div>
          }
          <div class="evidence-filter-control">
            <span class="evidence-filter-control__label">{{ 'facialEvidences.filters.employee' | translate }}</span>
            <mat-form-field class="evidence-filter-control__field" appearance="outline" subscriptSizing="dynamic">
              <mat-label>{{ 'facialEvidences.filters.employee' | translate }}</mat-label>
              <mat-icon matPrefix>badge</mat-icon>
              <mat-select
                [(ngModel)]="filters.employeeId"
                (selectionChange)="applyFilters()"
                (openedChange)="onEmployeeSelectOpened($event)"
                [disabled]="isLoadingEmployees">
                <mat-option class="employee-filter-search-option">
                  <div
                    class="employee-filter-search"
                    (mousedown)="$event.stopPropagation()"
                    (click)="$event.stopPropagation()">
                    <mat-icon>search</mat-icon>
                    <input
                      type="text"
                      [placeholder]="'formDialog.searchOption' | translate"
                      [value]="employeeSearchTerm"
                      autocomplete="off"
                      (mousedown)="$event.stopPropagation()"
                      (click)="$event.stopPropagation()"
                      (keydown)="$event.stopPropagation()"
                      (input)="onEmployeeSearchInput($event)">
                  </div>
                </mat-option>
                <mat-option value="">{{ 'facialEvidences.filters.allEmployees' | translate }}</mat-option>
                @for (employee of employees; track employee.employeeId) {
                  <mat-option [value]="employee.employeeId">
                    {{ employee.fullName || employee.employeeNumber }}
                    @if (employee.employeeNumber) {
                      <small> · {{ employee.employeeNumber }}</small>
                    }
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>

          <div class="evidence-filter-control">
            <span class="evidence-filter-control__label">{{ 'facialEvidences.filters.source' | translate }}</span>
            <mat-form-field class="evidence-filter-control__field" appearance="outline" subscriptSizing="dynamic">
              <mat-label>{{ 'facialEvidences.filters.source' | translate }}</mat-label>
              <mat-icon matPrefix>devices</mat-icon>
              <mat-select
                [(ngModel)]="filters.source"
                multiple
                (selectionChange)="applyFilters()">
                <mat-select-trigger>{{ sourceFilterLabel }}</mat-select-trigger>
                @for (source of sourceOptions; track source) {
                  <mat-option [value]="source">{{ ('facialEvidences.sources.' + source) | translate }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>

          <div class="evidence-filter-control">
            <span class="evidence-filter-control__label">{{ 'facialEvidences.filters.status' | translate }}</span>
            <mat-form-field class="evidence-filter-control__field" appearance="outline" subscriptSizing="dynamic">
              <mat-label>{{ 'facialEvidences.filters.status' | translate }}</mat-label>
              <mat-icon matPrefix>rule</mat-icon>
              <mat-select [(ngModel)]="filters.status" (selectionChange)="applyFilters()">
                <mat-option value="">{{ 'facialEvidences.filters.allStatuses' | translate }}</mat-option>
                @for (status of statusOptions; track status) {
                  <mat-option [value]="status">{{ ('facialEvidences.statuses.' + status) | translate }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>

          <app-date-time-picker-field
            class="evidence-date-filter"
            [label]="'facialEvidences.filters.dateFrom' | translate"
            [placeholder]="'facialEvidences.filters.dateFrom' | translate"
            [value]="filters.dateFrom"
            mode="date"
            (valueChange)="filters.dateFrom = $event; onDateFilterChange('dateFrom')">
          </app-date-time-picker-field>

          <app-date-time-picker-field
            class="evidence-date-filter"
            [label]="'facialEvidences.filters.dateTo' | translate"
            [placeholder]="'facialEvidences.filters.dateTo' | translate"
            [value]="filters.dateTo"
            mode="date"
            (valueChange)="filters.dateTo = $event; onDateFilterChange('dateTo')">
          </app-date-time-picker-field>

        </div>

        <div class="evidence-filters__actions">
          <button
            mat-icon-button
            class="evidence-filters__refresh"
            (click)="refreshEvidences()"
            [disabled]="isLoading"
            [matTooltip]="'facialEvidences.actions.refresh' | translate">
            <mat-icon>refresh</mat-icon>
          </button>
          <button
            mat-icon-button
            class="evidence-filters__clear"
            (click)="clearFilters()"
            [matTooltip]="'facialEvidences.actions.clearFilters' | translate">
            <mat-icon>filter_alt_off</mat-icon>
          </button>
        </div>
      </section>

      @if (isLoading) {
        <app-loading-state
          class="facial-evidence__loading"
          [overlay]="false"
          [message]="'facialEvidences.loading' | translate" />
      } @else if (!evidences.length) {
        <div class="facial-evidence__state facial-evidence__state--empty">
          <span class="facial-evidence__state-icon"><mat-icon>no_photography</mat-icon></span>
          <strong>{{ 'facialEvidences.empty.title' | translate }}</strong>
          <span>{{ 'facialEvidences.empty.message' | translate }}</span>
          <button mat-stroked-button (click)="clearFilters()">
            <mat-icon>restart_alt</mat-icon>
            {{ 'facialEvidences.actions.reset' | translate }}
          </button>
        </div>
      } @else {
        <div class="evidence-grid-scroll">
          <div class="evidence-grid">
            @for (event of evidences; track trackEvidence($index, event)) {
              <article class="evidence-card">
              <button
                type="button"
                class="evidence-card__media"
                [class.evidence-card__media--unavailable]="!event.imageUrl || event.imageFailed"
                (click)="openEvidence(event)"
                [attr.aria-label]="event.employeeLabel">
                @if (event.imageUrl && !event.imageFailed) {
                  <img
                    [src]="event.imageUrl"
                    [alt]="event.employeeLabel"
                    loading="lazy"
                    (error)="markImageFailed(event)">
                  <span class="evidence-card__zoom"><mat-icon>zoom_in</mat-icon></span>
                } @else {
                  <span class="evidence-card__placeholder">
                    <mat-icon>face</mat-icon>
                    <strong>{{ 'facialEvidences.gallery.noImage' | translate }}</strong>
                    <small>{{ 'facialEvidences.gallery.noImageHint' | translate }}</small>
                  </span>
                }
                <span class="evidence-card__source evidence-card__source--{{ event.source }}">
                  <mat-icon>{{ event.source === 'kiosk' ? 'desktop_windows' : 'smartphone' }}</mat-icon>
                  {{ event.sourceLabel }}
                </span>
                <span class="evidence-card__face-status evidence-card__face-status--{{ faceTone(event.faceValidationStatus) }}">
                  <mat-icon>{{ event.faceValidationStatus === 'passed' ? 'verified' : event.faceValidationStatus === 'failed' ? 'gpp_bad' : 'help_outline' }}</mat-icon>
                  {{ event.faceStatusLabel }}
                </span>
              </button>

              <div class="evidence-card__body">
                <div class="evidence-card__employee">
                  <span>{{ event.employeeLabel.charAt(0) || '?' }}</span>
                  <div>
                    <h3>{{ event.employeeLabel }}</h3>
                    <p>{{ event.employeeNumber || '—' }}</p>
                  </div>
                </div>

                <div class="evidence-card__details">
                  <div>
                    <mat-icon>schedule</mat-icon>
                    <span>{{ event.eventAtLabel }}</span>
                  </div>
                  <div>
                    <mat-icon>login</mat-icon>
                    <span>{{ event.eventTypeLabel }}</span>
                  </div>
                </div>

                <footer class="evidence-card__footer">
                  <span class="status-pill status-pill--{{ statusTone(event.status) }}">
                    <i></i>{{ event.statusLabel }}
                  </span>
                  @if (event.imageUrl && !event.imageFailed) {
                    <button
                      mat-icon-button
                      [matTooltip]="'facialEvidences.actions.view' | translate"
                      (click)="openEvidence(event)">
                      <mat-icon>open_in_full</mat-icon>
                    </button>
                  }
                </footer>
              </div>
              </article>
            }
          </div>
        </div>

        <mat-paginator
          class="evidence-paginator"
          [length]="totalItems"
          [pageIndex]="currentPage - 1"
          [pageSize]="pageSize"
          [pageSizeOptions]="[12, 24, 48]"
          [showFirstLastButtons]="true"
          (page)="onPageChange($event)">
        </mat-paginator>
      }
    </div>
  </div>
</section>

@if (selectedEvidence) {
  <div class="evidence-viewer" role="dialog" aria-modal="true" (click)="closeEvidence()">
    <div class="evidence-viewer__panel" (click)="$event.stopPropagation()">
      <div class="evidence-viewer__header">
        <div>
          <span>{{ 'facialEvidences.viewer.eyebrow' | translate }}</span>
          <h2>{{ selectedEvidence.employeeLabel }}</h2>
          <p>{{ selectedEvidence.employeeNumber }} · {{ selectedEvidence.eventAtLabel }}</p>
        </div>
        <button mat-icon-button (click)="closeEvidence()" [attr.aria-label]="'common.close' | translate">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <div class="evidence-viewer__content">
        <div class="evidence-viewer__image">
          <img [src]="selectedEvidence.imageUrl" [alt]="selectedEvidence.employeeLabel">
        </div>
        <aside class="evidence-viewer__info">
          <div class="evidence-viewer__status">
            <span class="evidence-card__face-status evidence-card__face-status--{{ faceTone(selectedEvidence.faceValidationStatus) }}">
              <mat-icon>verified_user</mat-icon>{{ selectedEvidence.faceStatusLabel }}
            </span>
            <span class="status-pill status-pill--{{ statusTone(selectedEvidence.status) }}">
              <i></i>{{ selectedEvidence.statusLabel }}
            </span>
          </div>
          <dl>
            <div>
              <dt>{{ 'facialEvidences.fields.source' | translate }}</dt>
              <dd>{{ selectedEvidence.sourceLabel }}</dd>
            </div>
            <div>
              <dt>{{ 'facialEvidences.fields.eventType' | translate }}</dt>
              <dd>{{ selectedEvidence.eventTypeLabel }}</dd>
            </div>
            <div>
              <dt>{{ 'facialEvidences.fields.device' | translate }}</dt>
              <dd>{{ selectedEvidence.deviceId || '—' }}</dd>
            </div>
            <div>
              <dt>{{ 'facialEvidences.fields.file' | translate }}</dt>
              <dd>{{ selectedEvidence.faceEvidence?.fileName || '—' }}</dd>
            </div>
          </dl>
          <a
            mat-flat-button
            color="primary"
            [href]="selectedEvidence.imageUrl"
            target="_blank"
            rel="noopener noreferrer">
            <mat-icon>open_in_new</mat-icon>
            {{ 'facialEvidences.actions.openOriginal' | translate }}
          </a>
        </aside>
      </div>
    </div>
  </div>
}
